/* eslint-disable react/prop-types */
import ErrorMessage from "components/ErrorMessage";
import InlineLoading from "components/InlineLoading";
import useSWR from "swr";

const fetcher = async (url) => {
  const res = await fetch(url);
  if (!res.ok) {
    const error = new Error("An error occurred while fetching the data.");
    // Attach extra info to the error object.
    error.info = await res.json();
    error.status = res.status;
    throw error;
  }
  return res.json();
};

const CategoriesByGroup = ({
  groupId = null,
  render = null,
  loadingComponent = null,
}) => {
  const {
    data,
    error,
    isValidating: loading,
  } = useSWR(groupId ? `/api/categories?groupId=${groupId}` : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  if (loading) return loadingComponent || <InlineLoading />;
  if (error) return <ErrorMessage error={error} />;

  // The API returns { categories, totalCount }, we need categories for the render prop
  const categories = data?.categories;

  // Ensure categories is an array and render is a function before calling
  if (!Array.isArray(categories) || typeof render !== "function") {
    // Optionally, handle this case, e.g., return null or a message
    return null;
  }

  const output = render(categories);

  return <>{categories && output}</>;
};

export default CategoriesByGroup;
